import type {ComponentProps} from 'react';
import {cn} from '@/lib/utils';
/**
 * Places an icon inside an input. When the group also holds a label or an error message, set
 * `--input-group-height` to the input's height so the icon stays centered on the input.
 */
export function InputGroup({
  children,
  position = 'left',
  className,
  ...props
}: ComponentProps<'div'> & {position?: 'left' | 'right'}) {
  return (
    <div
      className={cn(
        'relative min-w-0 [&>svg]:pointer-events-none [&>svg]:absolute [&>svg]:top-[calc(var(--input-group-height,100%)/2)] [&>svg]:size-4 [&>svg]:-translate-y-1/2 [&>svg]:text-muted-foreground',
        // Inset like PrimeReact's IconField so the icon clears the pill's rounded end.
        position === 'left' ? '[&_input]:pl-10 [&>svg]:left-4' : '[&_input]:pr-10 [&>svg]:right-4',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
export function InputAdornment(props: ComponentProps<'span'>) {
  return <span {...props} />;
}
